export default __webpack_public_path__ + "static/media/phone.4b692d95.png";